<template>
  <div class="card-container d-flex flex-column justify-content-center align-items-center align-content-center">
    <div class="w-100 d-flex align-items-center my-4">
      <div class="card-content d-flex flex-column justify-content-center align-items-center w-100">
        <table class="table mb-0">
          <thead v-if="Object.keys(user).length != 0">
            <tr v-if="user.firstName">
              <th colspan="2" class="text-center"><h1>
                {{user.firstName + ' '+ user.lastName}}
              </h1></th>
            </tr>
            <tr v-if="user.jobTitle != '' || user.companyName != ''">
              <th colspan="2" class="text-center"><i v-if="user.jobTitle != ''">{{user.jobTitle}}</i><span v-if="user.jobTitle != '' && user.companyName != ''"> at </span><span v-if="user.companyName != ''">{{user.companyName}}</span></th>
            </tr>
            <tr>
              <th colspan="2" class="text-center">
                <a :href="`mailto:${user.email}`" class="btn btn-sm btn-outline-success mr-4">Email</a>
                <a :href="`tel:${user.phoneNum}`" class="btn btn-sm btn-outline-success">Call</a>
              </th>
            </tr>
          </thead>
          <tbody v-if="Object.keys(user).length != 0">
            <tr v-if="user.email != ''">
              <th>Email</th>
              <td>{{user.email}}</td>
            </tr>
            <tr v-if="user.phoneNum != ''">
              <th >Mobile</th>
              <td><a :href="`tel:${user.phoneNum}`">{{user.phoneNum}}</a></td>
            </tr>
            <tr v-if="user.workNum != ''">
              <th>Work</th>
              <td><a :href="`tel:${user.workNum}`">{{user.workNum}}</a></td>
            </tr>
            <tr v-if="user.workNum2 != ''">
              <th>Work 2</th>
              <td><a :href="`tel:${user.workNum2}`">{{user.workNum2}}</a></td>
            </tr>
          </tbody>
        </table>
        <ul class="icon-list list-inline mt-4 mb-0">
          <li class="list-inline-item" v-if="user.website != ''">
            <a :href="user.website" target="_blank" title="Website" alt="Website"><WebsiteLogo/></a>
          </li>
          <li class="list-inline-item" v-if="user.linkedIn != ''">
            <a :href="user.linkedIn" target="_blank" title="LinkedIn" alt="LinkedIn"><LinkedInLogo/></a>
          </li>
          <li class="list-inline-item" v-if="user.twitter != ''">
            <a :href="user.twitter" target="_blank" title="Twitter" alt="Twitter"><TwitterLogo/></a>
          </li>
        </ul>
        <a :download="fullname + '.vcf'" :href="vcfBlob" class="btn btn-sm btn-outline-success mt-4" v-if="Object.keys(user).length != 0">Save Contact</a>
      </div>
    </div>


    <div class="credit d-flex align-items-center mb-4">
      <router-link to="/" v-if="!(this.user.email || '').includes('pension.gov')">
        <Logo />
      </router-link>
      <a href="https://www.pension.gov.ae/en-us/pages/default.aspx" target="_blank" v-else>
        <img src="https://www.pension.gov.ae/Documents/res/images/pension-logo.png" alt="">
      </a>

      <router-link to="/create" v-if="!(this.user.email || '').includes('pension.gov')">
        <button class="btn btn-outline-success ml-4">Create Your Own</button>
      </router-link>
    </div>

    <Footer v-if="!(this.user.email || '').includes('pension.gov')"/>
  </div>
</template>

<script>
import axios from 'axios'
import vCardsJS from 'vcards-js'
const Logo = () => import('../components/Logo')
const Header = () => import('../components/Header')
const Footer = () => import('../components/Footer')

const LinkedInLogo = () => import('../components/icons/LinkedInLogo')
const TwitterLogo = () => import('../components/icons/TwitterLogo')
const WebsiteLogo = () => import('../components/icons/WebsiteLogo')

export default {
  data() {
    return {
      user: {},
      vcfBlob: ''
    }
  },
  metaInfo() {
    return {
      meta: [
        { name: 'robots', content: 'noindex' }, 
      ]
    }
  },
  components: {
    Header, Logo, Footer, LinkedInLogo, TwitterLogo, WebsiteLogo
  },
  computed: {
    fullname: function() {
      return this.user.firstName + ' ' + this.user.lastName
    }
  },
  methods: {
    changeTheme: function() {
      if(this.user.theme_color == 'light' || (this.user.email || "").includes("pension.gov")) {
        document.body.setAttribute("data-theme", "light")
      }
      if((this.user.email || "").includes("pension.gov")) {
        document.body.setAttribute("data-company", "pension")
      }
    },
    vcf: function() {
      var vCard = vCardsJS();

      //set properties
      vCard.firstName = this.user.firstName;
      vCard.lastName = this.user.lastName;
      vCard.organization = this.user.companyName;
      vCard.email = this.user.email;
      vCard.cellPhone = this.user.phoneNum;
      vCard.workPhone = this.user.workNum;
      vCard.title = this.user.jobTitle;
      vCard.url = this.user.website;
      vCard.socialUrls['linkedIn'] = this.user.linkedIn;
      vCard.socialUrls['twitter'] = this.user.twitter;

      this.vcfBlob = "data:text/vcard;base64," + window.btoa(vCard.getFormattedString());
    },
    fetchQr: function() {
      axios
      .get(process.env.VUE_APP_API+'/card/get.php?user_key=' + this.$route.params.id, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      .then( (response) => {
        this.user = response.data
        this.vcf()
        this.changeTheme()
      });
    }
  },
  beforeMount() {
    this.fetchQr();
    console.log(process.env.VUE_APP_API)
  }
}
</script>
<style scoped>
table td {
  word-break: break-all;
}
</style>